import React, {Component} from 'react';
import {StatsCard} from '../../components/StatsCard/StatsCard.jsx';
import posIcon from "../../assets/img/pos.png";
class Kpi extends Component {
    render() {

        if(this.props.title=='Innoviti\'s EDC transacted') {
            return (
                <StatsCard
                    bigIcon={<img src={posIcon} alt={posIcon} />}
                    statsText={this.props.title}
                    statsValue={this.props.amount}
                />
            );
        }
        else {
            return (
                <StatsCard
                    bigIcon={<i className={this.props.cssClass +" text-success"}></i>}
                    statsText={this.props.title}
                    statsValue={this.props.amount}
                />
            );
        }

    }
}

export default Kpi;